import { useState } from "react";
import { JobType } from "../../models/JobType";
import { Sector } from "../../models/Sector";
import { Button } from "./Buttons/Button";
import { ReactComponent as Icon } from '../../assets/svg/drop_down.svg';
import { SectorSelect } from "../../components/Search/SectorSelect";
import { JobTypeSelect } from "../Search/JobTypeSelect";
import { SingleSelect } from "./SingleSelect";
import { SelectInputs } from "../../models/SelectInputs";
import { useMediaQuery } from "react-responsive";

interface Props {
    styles: any;
    sectors: Sector[];
    jobTypes: JobType[];
    sectorId: string;
    jobTypeId: string;
    applicationType: string;
    isMasterOrgAdmin: boolean;
    orgSelectInputs?: SelectInputs; 
    onSectorChange(value: number): void;
    onJobTypeChange(value: number): void;
    onApplicationTypeChange(type: string): void;
    onOrganizationChange(orgId: number): void;
    onClearAll(): void;
    onApply(): void;
}

export const RecruiterFilterPanel: React.FC<Props> = (props) => {
    const styles = props.styles;
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" }); 
    const [sectorsHovered, setSectorsHovered] = useState<boolean>(false);
    const [jobTypesHovered, setJobTypesHovered] = useState<boolean>(false);

    const applicationTypeOptions = [
        {"value": "ALL", "option": "All"},
        {"value": "CV", "option": "CV Based"},
        {"value": "CVLESS", "option": "CV Less"}
    ];

    const typeSelectInputs: SelectInputs = {
        default: applicationTypeOptions.find(o => o.value === props.applicationType)?.option ?? "All",
        options: applicationTypeOptions
    }

    const selectSector = (sectorId: number) => {
        props.onSectorChange(sectorId);
    }

    const selectJobType = (jobTypeId: number) => {
        props.onJobTypeChange(jobTypeId);
    }

    return (
        <div style={styles.panel}>
            <div style={styles.body}>
                {props.isMasterOrgAdmin && (
                    <div style={styles.section}>
                        <div style={styles.sectionTitle}>{"Organization"}</div>
                        <SingleSelect styles={styles.orgSelect} selectInputs={props.orgSelectInputs!} getSelected={props.onOrganizationChange} />
                    </div>
                )}
                {props.sectors.length > 0 && ( 
                    <div style={styles.section}>
                        <div style={styles.sectionTitle}>{"Sector"}</div>
                        <div style={styles.sectorSelectWrapper} onMouseEnter={() => setSectorsHovered(true)} onMouseLeave={() => setSectorsHovered(false)} onClick={() => setSectorsHovered(!sectorsHovered)}>
                            <span style={styles.sectorSelectWrapper.title}>Sector</span>
                            <Icon style={{...styles.buttonIcon, ...(sectorsHovered && styles.buttonIcon.hover)}}/> 
                            {sectorsHovered && <SectorSelect styles={styles.sectorSelect} sectors={props.sectors} selectOption={selectSector} />}
                        </div>
                    </div>
                )}
                {props.jobTypes.length > 0 && (
                    <div style={styles.section}>
                        <div style={styles.sectionTitle}>{"Job Type"}</div>
                        <div style={styles.jobTypeSelectWrapper} onMouseEnter={() => setJobTypesHovered(true)} onMouseLeave={() => setJobTypesHovered(false)} onClick={() => setJobTypesHovered(!jobTypesHovered)}>                      
                            <span style={styles.sectorSelectWrapper.title}>Job Type</span>
                            <Icon style={{...styles.buttonIcon, ...(jobTypesHovered && styles.buttonIcon.hover)}}/> 
                            {jobTypesHovered && <JobTypeSelect styles={styles.jobTypeSelect} jobTypes={props.jobTypes} selectOption={(jobTypeId: number) => selectJobType(jobTypeId) }/>}
                        </div>
                    </div>
                )}
                <div style={styles.section}>
                    <div style={styles.sectionTitle}>{"Application Type"}</div>
                    <SingleSelect
                        styles={{
                            ...styles.typeSelect,
                            hover: {
                                ...styles.typeSelect.hover,
                                width: (!isMobile && props.sectors.length === 0)
                                    ? "34.68vw"
                                    : (!isMobile && !props.isMasterOrgAdmin)
                                        ? "22.65vw"
                                        : styles.typeSelect.hover.width
                            }
                        }}
                        selectInputs={typeSelectInputs} 
                        getSelected={props.onApplicationTypeChange} 
                    />
                </div>
            </div>
            <div style={styles.footer}>
                <Button style={styles.clearButton} onClick={props.onClearAll}>{"Clear all"}</Button>
            </div>
        </div>
    );
}
